
import * as React from "react"

// Adjusted mobile breakpoint for better device detection
const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(false)

  React.useEffect(() => {
    // Set initial value based on current window width
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    
    // Handle device orientation changes and resizing
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    
    // Add event listeners for both resize and orientation change
    window.addEventListener("resize", handleResize)
    window.addEventListener("orientationchange", handleResize)
    
    // Clean up event listeners
    return () => {
      window.removeEventListener("resize", handleResize)
      window.removeEventListener("orientationchange", handleResize)
    }
  }, [])

  return isMobile
}
